var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: !0 });
import { markRaw, createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  viewBox: "0 0 24 24",
  width: "1.2em",
  height: "1.2em"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("g", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2"
    }, [
      createElementVNode("path", { d: "M10 12a2 2 0 1 0 4 0a2 2 0 0 0-4 0" }),
      createElementVNode("path", { d: "M21 12q-3.6 6-9 6t-9-6q3.6-6 9-6t9 6" })
    ], -1)
  ]));
}
__name(render, "render");
const IconEye = markRaw({ name: "tabler-eye", render });
export {
  IconEye as default
};
//# sourceMappingURL=eye.js.map
